import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';
import Logger from 'utilities/logger';

const useGetUserTaxDocuments = () => {
  const logger = Logger('useGetUserTaxDocuments');
  const context = useAuthContext(
    'tax_documents:read,tax_documents_log:read,users:read,tax_documents:edit',
  );
  const client = useApolloClient();
  logger.info({ context });
  const getDocuments = useCallback(
    (ssn, email) =>
      client
        .query({
          query: Queries.getUserTaxDocuments,
          variables: { ssn, email },
          fetchPolicy: 'network-only',
          context,
        })
        .then(response => ({
          w2s: (response.data.getUser || {}).taxDocuments || [],
          w4s: response.data.w4Documents || [],
          td1s: response.data.td1Documents || [],
          logs: (response.data.getUser || {}).taxDocumentLogEntries || [],
        })),
    [client, context],
  );
  return getDocuments;
};

export default useGetUserTaxDocuments;
